import { NotificationSound } from '../../typings/notificationPayload'

export const constants = {
  SUBSCRIPTION_TYPES: ['all-convos', 'my-convos', 'no-participants'],
  SAVED_FILTER_TYPE: { PUSH: 'push', EMAIL: 'email' },
  SOUND_OPTIONS: [
    { label: 'Ding', value: NotificationSound.DING },
    { label: 'Click', value: NotificationSound.CLICK },
    { label: 'Glossy', value: NotificationSound.GLOSSY },
    { label: 'Pop', value: NotificationSound.POP },
    { label: 'Xylophone', value: NotificationSound.XYLOPHONE }
  ],
  INTEGRATION_OPTIONS: [
    { label: 'Salesforce', value: 'salesforceFirstErrorEnabled' },
    { label: 'Marketo', value: 'marketoFirstErrorEnabled' },
    { label: 'Hubspot', value: 'hubspotFirstErrorEnabled' },
    { label: 'Eloqua', value: 'eloquaFirstErrorEnabled' }
  ],
  NOTIFICATION_PROPERTIES: [
    'adminIntegrationToggleNotification',
    'classification-notifications',
    'classifications-to-notify-on',
    'dailyAdminEmail',
    'disableNewTeammateEmails',
    'follow_accounts',
    'has_outreach_notifications',
    'historicalPerformanceEmail',
    'humane-notifications-browser-sound',
    'humane-notifications-email',
    'no_notifications_without_tab_open',
    'notifications-snoozed',
    'outboundNotificationSettings',
    'require-notification-interaction'
  ],
  NOTIFICATIONS_HELP_LINK: 'https://gethelp.drift.com/hc/en-us/articles/360041872393',
  TROUBLESHOOT_NOTIFICATIONS_LINK:
    'https://gethelp.drift.com/hc/en-us/articles/1260801353670-How-To-Troubleshoot-Desktop-App-Notifications',
  UPDATE_EMAIL_LINK: 'https://app.drift.com/settings2/account'
}

export default constants
